import * as S from './AppSection.styles'
import GlassButton from 'components/GlassButton/GlassButton'
import { useOneLinkUrl } from 'hooks/useOneLinkUrl'
import {
  type CtaLink,
  MULTI_PRODUCT_APP_INTRO_VIDEO,
  MULTI_PRODUCT_APP_ONELINK,
  MULTI_PRODUCT_NAV_STATE,
  MULTI_PRODUCT_VIDEO_FOLDER,
} from '../../multiProductHomePage.consts'

type Props = {
  title: string
  subtitle: string
  download: CtaLink
}

export default function AppSection({ title, subtitle, download }: Props) {
  const oneLinkUrl = useOneLinkUrl(MULTI_PRODUCT_APP_ONELINK)

  return (
    <S.Container data-testid="multi-product-app">
      <S.Video
        cldId={MULTI_PRODUCT_APP_INTRO_VIDEO}
        folder={MULTI_PRODUCT_VIDEO_FOLDER}
        name="App Intro"
        type="Video"
      />
      <S.Content>
        <S.TextBlock>
          <S.Title>{title}</S.Title>
          <S.Subtitle>{subtitle}</S.Subtitle>
        </S.TextBlock>
        <GlassButton
          variant="primary"
          size="large"
          to={oneLinkUrl ?? download.to}
          state={MULTI_PRODUCT_NAV_STATE}
          onClick={download.onClick}
          data-testid="app-download"
        >
          {download.label}
        </GlassButton>
      </S.Content>
    </S.Container>
  )
}
